import WebsiteDescriptor from './WebsiteDescriptor.jsx';

import './Websites.css';

const Websites = () => (
  <div id="Websites">
		<h2>Websites</h2>
    <div>
      <WebsiteDescriptor label="sopholophie.com" online={true} code="https://github.com/funkjunky/jayeh_2015">
        <p>The website you are on now!</p>
        <p>I wanted to make this a very simple scrolling business card style website</p>
        <p>However, I also want to show that I can create nice looking designs</p>
      </WebsiteDescriptor>
      <WebsiteDescriptor label="jayeh.ca" online={false} code="https://github.com/funkjunky/jayeh_2015">
        <p>The second version of my old website. It was built in react and used a markdown React plugin I made.</p>
        <p>I had a blog going, but I wasn't very consistent with it.</p>
        <p>It did include a lot of interactive javascript tho!</p>
      </WebsiteDescriptor>
      <WebsiteDescriptor label="brandicted.com" online={false}>
        <p>I made an infinite scroll jquery plugin for them back in 2013</p>
        <p>The website was slick and use dpostgres on the backend</p>
        <p>The idea was silly. People don't need a platform exclusive for following brands.</p>
      </WebsiteDescriptor>
      <WebsiteDescriptor label="thebrane.com" online={false}>
        <p>I helped with the inference engine for this graph based encyclopedia</p>
        <p>It used a graph based database backend, which was fun to work in</p>
        <p>The exec would trick devs to work for them, then delay and never pay them</p>
      </WebsiteDescriptor>
    </div>
  </div>
);

export default Websites;
